import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
const NAMES = ['María G.', 'Juan P.', 'Sofía L.', 'Mateo R.', 'Valentina C.', 'Martín S.', 'Lucía F.', 'Agustín M.', 'Camila V.', 'Nicolás B.', 'Martina D.', 'Joaquín H.', 'Catalina P.', 'Tomás G.', 'Florencia A.', 'Santiago L.', 'Julieta M.', 'Facundo R.', 'Micaela T.', 'Emiliano C.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Corrientes'];
interface PopupData {
  name: string;
  city: string;
  minutesAgo: number;
}
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState<PopupData | null>(null);
  const generateRandomData = useCallback(() => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    const randomMinutes = Math.floor(Math.random() * 59) + 1;
    return {
      name: randomName,
      city: randomCity,
      minutesAgo: randomMinutes
    };
  }, []);
  useEffect(() => {
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNextPopup = (isFirst = false) => {
      // First appearance after 8-12s, subsequent after 40-60s
      const delay = isFirst ? Math.floor(Math.random() * (12000 - 8000 + 1) + 8000) : Math.floor(Math.random() * (60000 - 40000 + 1) + 40000);
      showTimeout = setTimeout(() => {
        setData(generateRandomData());
        setIsVisible(true);
        // Hide after 5-6 seconds
        const visibleDuration = Math.floor(Math.random() * (6000 - 5000 + 1) + 5000);
        hideTimeout = setTimeout(() => {
          setIsVisible(false);
          scheduleNextPopup(false); // Schedule next one after hiding
        }, visibleDuration);
      }, delay);
    };
    scheduleNextPopup(true);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [generateRandomData]);
  return <AnimatePresence data-id="element-265">
      {isVisible && data && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 right-4 md:right-auto md:w-80 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 z-50 flex items-start gap-3" data-id="element-266">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-267">
            <X size={16} data-id="element-268" />
          </button>

          <div className="flex-shrink-0 w-10 h-10 bg-brand-orange/10 rounded-full flex items-center justify-center text-brand-orange" data-id="element-269">
            <ShoppingBag size={20} data-id="element-270" />
          </div>

          <div className="flex-1 pr-4" data-id="element-271">
            <p className="text-sm font-semibold text-brand-navy leading-tight" data-id="element-272">
              {data.name} de {data.city}, Argentina
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-273">
              acaba de comprar el Mega Pack Sin Pantallas
            </p>
            <div className="flex items-center gap-1 mt-2 text-[10px] text-gray-400 font-medium" data-id="element-274">
              <CheckCircle2 size={12} className="text-brand-green" data-id="element-275" />
              <span data-id="element-276">
                Comprador verificado • hace {data.minutesAgo}{' '}
                {data.minutesAgo === 1 ? 'minuto' : 'minutos'}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}